import React from "react";

const BlueButton = ({ title, onChangeValue, disabled, color }) => {
    return (
        <button
            className={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
            disabled={disabled}
            style={{ backgroundColor: color }}
            type="button"
            onClick={onChangeValue}
        >
            {title}
        </button>
    );
};

export default BlueButton;
